import React from 'react';
import { Navbar } from 'flowbite-react';
import { Link } from 'react-router-dom';

const NavbarComponents = () => {
    return (
        <div className='px-2 border-b border-solid border-stone-200'>
            <Navbar
                fluid={true}
                rounded={false}
            >
                <Link to="/" className="flex items-center">
                    <img src="https://t4.ftcdn.net/jpg/05/05/61/73/240_F_505617309_NN1CW7diNmGXJfMicpY9eXHKV4sqzO5H.jpg"
                        className="mr-3 h-6 sm:h-9" alt="Job Vacancy" />
                    <span className="self-center text-xl font-semibold whitespace-nowrap dark:text-white">Job Vacancy</span>
                </Link>
                <Navbar.Toggle />
                <Navbar.Collapse>
                    <li>
                        <Link to="/dashboard" className="block py-2 pr-4 pl-3 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">
                            Dashboard
                        </Link>
                    </li>
                    <li>
                        <Link to="/dashboard/list-job-vacancy" className="block py-2 pr-4 pl-3 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">
                            Manage Data
                        </Link>
                    </li>
                    <li>
                        <Link to="/list-job" className="block py-2 pr-4 pl-3 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">
                            List Job Vacancy
                        </Link>
                    </li>
                    <li>
                        <Link to="/dashboard/list-job-vacancy/form" className="block py-2 pr-4 pl-3 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">
                            Form Job
                        </Link>
                    </li>
                </Navbar.Collapse>
            </Navbar>
        </div>
    )
}

export default NavbarComponents
